import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
// ====== end of interface import section ====== //

type pointInfo = {
  history: any;
  routes: any;
};

type stateToProps = {};

/**
 * Point Info User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {pointInfo} props for this component.
 * @return {JSX.Element}
 */
function PointInfo({ history, routes }: pointInfo): JSX.Element {
  return <div>Point Info</div>;
}

const mapStateToProps = (state: stateToProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PointInfo);
